<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 雁阵系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>数据管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.typeId" placeholder="请选择产品类型" @change="onChangeTypeId">
					<el-option key="" label="请选择产品类型" value=""></el-option>
					<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.productSeriesId" placeholder="请选择产品系列" filterable>
					<el-option key="" label="请选择产品系列" value=""></el-option>
					<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select> &nbsp;
				<el-input v-model="query.productName"  placeholder = "请输入产品型号" class="handle-input mr10"></el-input>
				<el-checkbox v-model="query.productSeriesOnly" placeholder="只显示系列">只显示系列</el-checkbox> &nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-download" @click="handleExport" v-if = "controll['export']">生成html</el-button>
				<el-button type="primary" icon="el-icon-download" @click="handleExportMapping" v-if = "controll['export']">导出查询映射</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="brand" label="品牌" width="150"></el-table-column>
				<el-table-column prop="productSeriesName" label="产品系列""></el-table-column>
                <el-table-column prop="productName" label="产品名称" width="180"></el-table-column>
				<el-table-column prop="price" label="单价" width="150">
					<template slot-scope="scope" v-if="scope.row.price">
						￥{{scope.row.price}}
                    </template>
				</el-table-column>
				<el-table-column prop="image" label="图片" width="150">
					<template slot-scope="scope" v-if="scope.row.image">
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in scope.row.image.split(',')">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="payReceiptItem"
									:preview-src-list="[payReceiptItem]"
								v-if="scope.row.image"></el-image>
							</div>
						</el-tooltip>
                    </template>
				</el-table-column>
                <el-table-column label="操作" width="280" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-coin"
                            @click="handleSetPrice(scope.$index, scope.row)"
							v-if = "controll['price'] && scope.row.productId != undefined"
                        >设置价格</el-button>
						<el-button
                            type="text"
                            icon="el-icon-document-copy"
                            @click="handleCopy(scope.$index, scope.row)"
							v-if = "controll['copy']"
                        >复制</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if = "controll['edit']"
                        >编辑</el-button>
						<el-button
						type="text"
						icon="el-icon-download"
						@click="downloadSingleHtml(scope.$index, scope.row)"
						v-if = "controll['export'] && scope.row.productId == undefined"
					>HTML下载</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if = "controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" fullscreen>
            <el-form ref="form" :model="form" label-width="150px" :rules="rules">
				<div style="position: absolute; right:30px;top:90px; z-index:1;">
					<el-button
						type="text"
						@click="showCode = true"
						v-if = "showCode == false"
					>HTML源码</el-button>
					<el-button
						type="text"
						@click="showCode = false"
						v-if = "showCode == true"
					>HTML可视化</el-button>  
				</div>
				<el-tabs v-model= "activeName" type="card">
					<el-tab-pane label="终止生产信息" name="terminationInfoTab" v-if="form.productId  == null&& form.terminationInfo">
						<div v-html= "form.terminationInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.terminationInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="描述" name="baseTab" v-if="form.productId == undefined && form.baseInfo">
						<div v-html= "form.baseInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.baseInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="用途" name="purposeTab" v-if="form.productId == undefined">
						<div v-html= "form.purposeInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.purposeInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="分类" name="categoryTab" v-if="form.productId == undefined">
						<div v-html= "form.categoryInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.categoryInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="规格" name="specificationsTab" v-if="form.productId == undefined">
						<div v-html= "form.specificationsInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.specificationsInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="尺寸" name="sizeTab">
						<div v-html= "form.sizeInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.sizeInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="参数" name="paramTab" v-if="form.productId">
						<div v-html= "form.paramInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.paramInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="可选配件" name="accessoryInfoTab" v-if="form.productId == undefined">
						<div v-html= "form.accessoryInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.accessoryInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="连接回路" name="connectInfoTab" v-if="form.productId == undefined">
						<div v-html= "form.connectInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.connectInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
					<el-tab-pane label="注意事项" name="noteInfoTab" v-if="form.productId == undefined">
						<div v-html= "form.noteInfo" v-if = "showCode == false" style="min-height:499px"></div>
						<el-input type=textarea :rows=25 v-model="form.noteInfo" v-if = "showCode == true"></el-input>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false :visible.sync="buildBarVisible" :show-close="false" width="280px">
            <el-progress type="circle" :percentage="progressAge" :stroke-width = "15" :width = "200" style="padding-left:20px;padding-right:20px;padding-buttom:20px;"></el-progress>
        </el-dialog>
		
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPromotionContentData, savePromotionContent, deletePromotionContent, getPromotionContent, getEnumValueKV, 
getProductSeriesKV, buildHTML, getWithTemplate, getOwnCompany, buildMapping} from '../../../api/index';

export default {
    name: 'promotion-content',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			activeName:"",
            editVisible: false,
            pageTotal: 0,
            form: {},
			title:"",
			rules: {
               
            },
			productTypeEnumCode:1003,
			productTypeKV:{},
			productSeriesKV:{},
			showCode: false,
			buildBarVisible:false,
			progressAge:0,
			controll:{},
			website:"",
        };
    },
    created() {
		this.controll = getControll("promotion-content");
		this.getProductType();
        this.getData();
		window.addEventListener('htmlBuildProgress', this.progressChange);
		this.getWebSite();
    },
	destroyed() {
		window.removeEventListener('htmlBuildProgress', this.progressChange)
	},
    methods: {
		getWebSite() {
			getOwnCompany().then(res => {
				if (res.code == 0 ) {
					this.website = res.data.website;
				} else {
					this.$message.error("获取企业信息失败！" + res.message);
				}
			});
		},
		//获取产品类型
		getProductType() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//产品类型变更
		onChangeTypeId(value) {
			this.productSeriesKV = {};
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchPromotionContentData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		handleExport() {
			this.$confirm('确定要生成html页面吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
				    buildHTML(this.query).then(res => {
						if (res.code == 0) {
							this.progressAge = 0;
							this.buildBarVisible = true;
						} else {
							this.$message.error(`提交生成html请求失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		handleExportMapping() {
			this.$confirm('确定要生成查询映射吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					const loading = this.$loading({
					  lock: true,
					  text: '正在生成...',
					  spinner: 'el-icon-loading',
					  background: 'rgba(0, 0, 0, 0.7)'
					});
				    buildMapping(this.query).then(res => {
						if (res.code == 0) {
							loading.close();
							var linkTag = document.createElement("a");
							linkTag.href = "/blob/export/download-mapping?key=" + res.data;			
							linkTag.click();
							linkTag.remove();
						} else {
							this.$message.error(`生成失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePromotionContent([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加用户信息";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.title = "编辑参数信息";
            getPromotionContent(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.activeName = (this.form.productId == undefined?(this.form.baseInfo == undefined?"terminationInfoTab":"baseTab"):"paramTab");
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		handleSetPrice(index, row) {
			this.$prompt('请输入新价格', '提示（' + row.productName + '）', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/,
				inputErrorMessage: '金额格式不正确'
			}).then(({ value }) => {
				let data = {}
				data["id"] = row.id;
				data["price"] = value;
				savePromotionContent(data).then(res => {
					if (res.code == 0) {
							this.$message.success('保存成功！');
							this.$set(row, "price", value)
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
				})
			});
		},
		handleCopy(index, row) {
			let url = this.website + "/product/product_" + row.productSeriesId 
			+ (row.productId?"_"+row.productId:"") + ".html";
			navigator.clipboard.writeText(url);
			this.$message.success('网址复制完成！');
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					savePromotionContent(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		progressChange(message) {
			let messageData = JSON.parse(message.detail);
			this.progressAge = Math.trunc(parseFloat(messageData.data.content) * 100);
			if (this.progressAge >= 100) {
				this.buildBarVisible = false;
				//this.$message.success(`html构建完成！`);
				this.openFullScreen(messageData.data.path);
			}
		},
		openFullScreen(path) {
			const loading = this.$loading({
				lock: true,
				text: '下载准备中，请稍等片刻...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			const downloadKey = path;
			setTimeout(() => {
				loading.close();
				var linkTag = document.createElement("a");
				linkTag.href = "/blob/export/download-html?key=" + path;			
				linkTag.click();
				linkTag.remove();
			}, 8000);
        },
		//下载
		downloadSingleHtml(index, row) {
			getWithTemplate(row.id).then(res => {
				if (res.code == 0) {
					this.$message.success(`生成html数据成功！`);
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/download-single-html?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
				} else {
					this.$message.error(`获取html数据详情失败！` + res.message);
				}
			});
		}
		
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
